module.exports = __webpack_public_path__ + "static/media/nienshanclogo.032ea788.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/nienshanclogo.png
// module id = 420
// module chunks = 0